import MojitoServices from 'mojito/services';
import { upperFirst } from 'mojito/utils';

const BetsTypes = MojitoServices.Bets.types;

const { OPEN, WON, LOST, VOID, CASHED_OUT, SAVED, PLACED } = BetsTypes.BET_STATUS;

/**
 * A utility class specifically designed for use within the `BetView` component.
 *
 * @class BetViewUtils
 * @name betViewUtils
 * @memberof Mojito.Modules.OpenBets
 */
export default class BetViewUtils {
    /**
     * Returns the corresponding leg/bet status icon config for a leg.
     *
     * @param {string} status - The status of the leg/bet.
     * @param {boolean} earlyPayoutAwarded - True if early payout is awarded.
     *
     * @returns {string} The config status for the leg/bet icon.
     * @function Mojito.Modules.OpenBets.betViewUtils.getStatusIcon
     */
    static getStatusIcon(status, earlyPayoutAwarded = false) {
        switch (status) {
            case OPEN:
                // Exceptional case for early payout awarded.
                // When the leg status is still open and early payout is awarded it should show as won.
                return earlyPayoutAwarded ? 'won' : 'open';
            case VOID:
                return 'void';
            case WON:
                return 'won';
            case LOST:
                return 'lost';
            case CASHED_OUT:
                return 'cashedOut';
            case SAVED:
                return 'saved';
            case PLACED:
                return 'placed';
        }
    }

    /**
     * Returns the config key for a bet status text.
     *
     * @param {string} betStatus - The status of the leg/bet.
     *
     * @returns {string} The config key for the leg/bet status text.
     * @function Mojito.Modules.OpenBets.betViewUtils.getStatusTextKey
     */
    static getStatusTextKey(betStatus) {
        return upperFirst(BetViewUtils.getStatusIcon(betStatus));
    }
}
